import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Card, CardBody, CardHeader, Badge } from 'reactstrap';
import { useSelector } from 'react-redux';

const ModalDetalleOT = ({ isOpen, toggle, ordenTrabajo }) => {
    const marcas = useSelector((state) => state.LegacyMarcas?.legacyMarcas || []);
    const modelos = useSelector((state) => state.LegacyModelos?.legacyModelos || []);

    const buscarNombreMarca = (codigo) => {
        if (Array.isArray(marcas) && marcas.length > 0 && codigo) {
            return marcas.find(m => m.MARCAS == codigo)?.DESCRI || codigo;
        }
        return codigo || '-';
    };

    const buscarNombreModelo = (codigo) => {
        if (Array.isArray(modelos) && modelos.length > 0 && codigo) {
            return modelos.find(m => m.MODELO == codigo)?.DESCRI || codigo;
        }
        return codigo || '-';
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;
        return date.toLocaleDateString('es-CL');
    };

    const formatTime = (timeString) => {
        if (!timeString) return '-';
        // Handle time format from SQL Server (HH:mm:ss)
        if (typeof timeString === 'string' && timeString.includes(':')) {
            return timeString.substring(0, 5);
        }
        return timeString;
    };

    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '-';
        return new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
            minimumFractionDigits: 0
        }).format(value);
    };

    const getEstadoLabel = (estado) => {
        const estados = {
            0: { label: 'Pendiente', color: 'warning' },
            1: { label: 'En Proceso', color: 'info' },
            2: { label: 'Terminada', color: 'success' },
            3: { label: 'Cerrada', color: 'secondary' },
            4: { label: 'Anulada', color: 'danger' }
        };
        return estados[estado] || { label: `Estado ${estado}`, color: 'light' };
    };

    if (!ordenTrabajo) return null;

    const estadoInfo = getEstadoLabel(ordenTrabajo.ESTADO);

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
            <ModalHeader toggle={toggle}>
                Detalle Orden de Trabajo #{ordenTrabajo.NUMEOT}
            </ModalHeader>
            <ModalBody>
                {/* Información General */}
                <Card className="mb-3">
                    <CardHeader className="bg-primary text-white">
                        <strong>Información General</strong>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={3}>
                                <label className="text-muted">N° Cita:</label>
                                <p className="fw-bold">{ordenTrabajo.NUMCTR || '-'}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">N° OT:</label>
                                <p className="fw-bold">{ordenTrabajo.NUMEOT}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Fecha OT:</label>
                                <p className="fw-bold">{formatDate(ordenTrabajo.FECOTR)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Estado:</label>
                                <div>
                                    <Badge color={estadoInfo.color}>{estadoInfo.label}</Badge>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={3}>
                                <label className="text-muted">Taller:</label>
                                <p className="fw-bold">{ordenTrabajo.TALLER || '-'}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Hora Inicio:</label>
                                <p className="fw-bold">{formatTime(ordenTrabajo.HORINI)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Tipo OT:</label>
                                <p className="fw-bold">{ordenTrabajo.TIPOTR || '-'}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Supervisor:</label>
                                <p className="fw-bold">{ordenTrabajo.SUPERV || '-'}</p>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Vehículo */}
                <Card className="mb-3">
                    <CardHeader className="bg-info text-white">
                        <strong>Vehículo</strong>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={3}>
                                <label className="text-muted">Patente:</label>
                                <p className="fw-bold">{ordenTrabajo.PATENT || '-'}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Marca:</label>
                                <p className="fw-bold">{buscarNombreMarca(ordenTrabajo.MARCAS)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Modelo:</label>
                                <p className="fw-bold">{buscarNombreModelo(ordenTrabajo.MODELO)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Año:</label>
                                <p className="fw-bold">-</p>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={3}>
                                <label className="text-muted">KM:</label>
                                <p className="fw-bold">{ordenTrabajo.LECTUR?.toLocaleString('es-CL') || '-'}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">N° Motor/VIN:</label>
                                <p className="fw-bold">{ordenTrabajo.NROVIN || '-'}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Chasis:</label>
                                <p className="fw-bold">-</p>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Cliente */}
                <Card className="mb-3">
                    <CardHeader className="bg-success text-white">
                        <strong>Cliente</strong>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={4}>
                                <label className="text-muted">RUT Cliente:</label>
                                <p className="fw-bold">{ordenTrabajo.CLIENT || '-'}</p>
                            </Col>
                            <Col md={4}>
                                <label className="text-muted">Nombre / Razón Social:</label>
                                <p className="fw-bold">-</p>
                            </Col>
                            <Col md={4}>
                                <label className="text-muted">Contacto:</label>
                                <p className="fw-bold">{ordenTrabajo.CONDUC || '-'}</p>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={4}>
                                <label className="text-muted">Tel. Contacto:</label>
                                <p className="fw-bold">{ordenTrabajo.FONCON || '-'}</p>
                            </Col>
                            <Col md={4}>
                                <label className="text-muted">E-mail Cliente:</label>
                                <p className="fw-bold">{ordenTrabajo.CEMAIL || '-'}</p>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Valores */}
                <Card className="mb-3">
                    <CardHeader className="bg-warning">
                        <strong>Valores</strong>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={3}>
                                <label className="text-muted">Valor OT:</label>
                                <p className="fw-bold">{formatCurrency(ordenTrabajo.VALORD)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Repuestos:</label>
                                <p className="fw-bold">{formatCurrency(ordenTrabajo.VALREP)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Materiales:</label>
                                <p className="fw-bold">{formatCurrency(ordenTrabajo.VALMAT)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Mano de Obra:</label>
                                <p className="fw-bold">{formatCurrency(ordenTrabajo.VALHHM)}</p>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={3}>
                                <label className="text-muted">Neto:</label>
                                <p className="fw-bold">{formatCurrency(ordenTrabajo.VALNET)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">IVA:</label>
                                <p className="fw-bold">{formatCurrency(ordenTrabajo.VALIVA)}</p>
                            </Col>
                            <Col md={3}>
                                <label className="text-muted">Total:</label>
                                <p className="fw-bold text-success">{formatCurrency(ordenTrabajo.VALTOT)}</p>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Observaciones */}
                <Card>
                    <CardHeader className="bg-secondary text-white">
                        <strong>Solicitud del Cliente / Observaciones</strong>
                    </CardHeader>
                    <CardBody>
                        <p style={{ whiteSpace: 'pre-wrap' }}>
                            {ordenTrabajo.OBSERV || 'Sin observaciones'}
                        </p>
                    </CardBody>
                </Card>
            </ModalBody>
        </Modal>
    );
};

export default ModalDetalleOT;
